// import React from "react";
// import Login from "./Login";

// const MsgDisplay = ({ msg }) => {
//   return <div>{msg == "Forbidden" ? <Login /> : msg}</div>;
// };

// export default MsgDisplay;

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MsgDisplay = ({ msg }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (msg === "Forbidden") {
      navigate("/");
    } else if (msg === "Unauthorized") {
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
  }, [msg, navigate]);

  return msg === "Forbidden" ? null : (
    <div
      className="cl-red"
      style={{
        color: "red",
        textAlign: "center",
        marginTop: "13px",
        fontSize: "18px",
      }}
    >{`You are not authorised to view this page (Token Invalid)`}</div>
  );
};

export default MsgDisplay;
